import React from "react";
import Tooltip from "../Tooltip/Tooltip.js";

export default class HorizontalStackedBarChart extends React.Component {
  constructor(props) {
    super(props);

    const data = this.props.data || [];

    this.state = {
      data: data,
      loading: data && data.length ? false : true,
    };

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    if (!this.state.data || this.state.data.length === 0) {
      this.loadData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.endpoint !== this.props.endpoint) {
      this.loadData();
    }
  }

  render() {
    // console.log(this.props)
    let data = null;
    let sum = null;

    if (this.state.data && this.state.data.length) {
      data = this.state.data.sort((a, b) => a.value - b.value);
      sum = data.reduce((accumulator, item) => accumulator + item.value, 0);
    }

    return (
      <div className="HorizontalStackedBarChart">
        {this.state.loading ? (
          <div className="loadingOverlay">
            <div className="spinner" />
          </div>
        ) : null}
        <h1 className="HorizontalStackedBarChart-title">{this.props.title}</h1>
        {data && data.length ? (
          <div>
            <div className="key">
              {data.map((b) => (
                <span className="key-category" key={b.name}>
                  <div
                    className="category-dot"
                    style={{
                      backgroundColor: b.color,
                    }}
                  />
                  {b.name} ({Number(b.value).toLocaleString()})
                </span>
              ))}
            </div>
            {sum > 0 ? (
              <div className="horizontial-bar-container">
                {data.map((b) => (
                  <Tooltip
                    key={b.name}
                    text={`${b.name}: ${Number(b.value).toLocaleString()}`}
                  >
                    <div
                      className="category-bar"
                      style={{
                        backgroundColor: b.color,
                        width: `${(b.value / sum) * 100}%`,
                      }}
                    />
                  </Tooltip>
                ))}
              </div>
            ) : null}
            <div className={"marker-container " + (sum > 0 ? "" : "no-data")}>
              <span className="low-marker">Low</span>
              <span className="high-marker">High</span>
            </div>
          </div>
        ) : (
          <div className="marker-container no-data"></div>
        )}
      </div>
    );
  }

  loadData() {
    this.setState({ loading: true });
    $.ajax({
      type: "GET",
      url: this.props.endpoint,
    }).done((data) => {
      //console.log('HorizontalStackedBarChart loadData done', data);
      this.setState({ data: data, loading: false });
    });
  }
}
